export function parseRadarQr(text=''){
  const raw=String(text||'').trim();
  if(!raw.startsWith('RADAR|')) return null;
  const out:Record<string,string>={raw};
  raw.split('|').slice(1).forEach(part=>{const i=part.indexOf('=');if(i>0)out[part.slice(0,i)]=part.slice(i+1)});
  if(!out.assessment) return null;
  return {version:out.v||'1',assessmentId:out.assessment,studentId:out.student||'',token:out.token||'',raw};
}

export function classifyBubbleScores(scores:number[], minDarkness=0.085, minGap=0.040){
  const letters=['A','B','C','D','E'];
  const clean=scores.map(v=>Math.max(0,Math.min(1,Number(v)||0)));
  const ranked=clean.map((v,i)=>({letter:letters[i],score:v,index:i})).sort((a,b)=>b.score-a.score);
  const best=ranked[0]||{letter:'',score:0}, second=ranked[1]||{letter:'',score:0};
  const third=ranked[2]||{score:0}, worst=ranked[ranked.length-1]||{score:0};
  const sortedAsc=[...clean].sort((a,b)=>a-b);
  const median=sortedAsc.length>=4?(sortedAsc[1]+sortedAsc[2])/2:(sortedAsc[Math.floor(sortedAsc.length/2)]||0);
  const range=best.score-worst.score;
  const gap=best.score-second.score;
  const secondGap=second.score-third.score;
  const baseline=(clean.reduce((a,b)=>a+b,0)-best.score)/Math.max(1,clean.length-1);
  const relative=best.score-baseline;
  const prominence=best.score-median;
  const absoluteBlank = best.score < minDarkness;
  const uniformBlank = range < 0.040 && best.score < 0.220;
  const noPeak = gap < 0.025 && prominence < 0.040 && relative < 0.035;
  if(absoluteBlank || uniformBlank || noPeak){
    return {selected:'',status:'blank',confidence:Math.max(.82,1-Math.min(1,best.score/.22)),best:best.score,second:second.score,gap,ratio:best.score?second.score/best.score:1,baseline,relative,prominence,range,scores:clean};
  }
  const threeHighAmbiguous = third.score>=0.120 && (third.score-worst.score)>=0.080 && (best.score-third.score)<0.140;
  if(threeHighAmbiguous){
    const selected=best.letter;
    return {selected,status:'low_confidence',confidence:.62,best:best.score,second:second.score,gap,ratio:best.score?second.score/best.score:1,baseline,relative,prominence,range,scores:clean};
  }
  const floor=(third.score+worst.score)/2;
  const bestLift=best.score-floor, secondLift=second.score-floor;
  const duplicateCandidate = second.score>=0.135 && bestLift>=0.105 && secondLift>=0.085 && Math.abs(best.score-second.score)<0.160 && secondGap>=0.055;
  if(duplicateCandidate){
    return {selected:'',status:'duplicate',confidence:.94,best:best.score,second:second.score,gap,ratio:best.score?second.score/best.score:1,baseline,relative,prominence,range,scores:clean};
  }
  const clearStrong = best.score>=0.130 && (gap>=minGap || prominence>=0.060 || relative>=0.055);
  const clearFaint  = best.score>=0.100 && gap>=0.065 && relative>=0.055;
  const clearlySingle = clearStrong || clearFaint || prominence>=0.085 || relative>=0.075;
  const selected=best.letter;
  const confidence=Math.max(0,Math.min(1, .60 + gap*2.8 + prominence*1.9 + relative*1.6));
  if(clearlySingle){
    return {selected,status:'recognized',confidence,best:best.score,second:second.score,gap,ratio:best.score?second.score/best.score:1,baseline,relative,prominence,range,scores:clean};
  }
  return {selected,status:'low_confidence',confidence:Math.min(.74,confidence),best:best.score,second:second.score,gap,ratio:best.score?second.score/best.score:1,baseline,relative,prominence,range,scores:clean};
}
